var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoThailand(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_\\uB808\\uC774\\uC5B4_2",
    "data-name": "\\uB808\\uC774\\uC5B4 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 309.83 40.82",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #717780;\n      }\n\n      .cls-2 {\n        fill: #040000;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "284.84 29.48 284.84 40.82 295.48 40.82 295.48 38.22 287.85 38.22 287.85 32.08 295.48 32.08 295.48 29.48 284.84 29.48"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 289.36,
    y: 33.89,
    width: 6.12,
    height: 2.53
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 266.14,
    y: 29.48,
    width: 3.02,
    height: 11.34
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 237.82,
    y: 29.48,
    width: 3.02,
    height: 11.34
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M260.1,29.48h-4.67l-4.85,11.34h3.34l.93-2.3h5.84l.93,2.3h3.34l-4.85-11.34ZM258.05,32l1.64,4.06h-3.85l1.64-4.06h.57Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "249.91 40.82 245.63 40.82 241.32 35.87 245.51 35.87 249.91 40.82"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "249.91 29.48 245.63 29.48 241.32 34.43 245.51 34.43 249.91 29.48"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M309.83,40.82l-2.83-3.99c1.43-.54,2.45-1.93,2.45-3.55h0c0-2.1-1.7-3.8-3.8-3.8h-7.91v11.34h3.02v-3.74h2.98l2.47,3.74h3.63ZM300.76,32.13h4.41c.7,0,1.26.57,1.26,1.26s-.57,1.26-1.26,1.26h-4.41v-2.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M271.48,29.48v11.34h3.02v-3.52h4.78c2.16,0,3.91-1.75,3.91-3.91h0c0-2.16-1.75-3.91-3.91-3.91h-7.8ZM274.49,34.64v-2.51h4.42c.69,0,1.26.56,1.26,1.26h0c0,.69-.56,1.26-1.26,1.26h-4.42Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M114.7,22.51h-7.36c-3.54,0-6.41-2.88-6.41-6.41V6.26h3.62v9.84c0,1.54,1.25,2.79,2.79,2.79h3.74V6.26h3.62v16.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M167.28,22.55h-3.62v-9.84c0-1.54-1.25-2.79-2.79-2.79h-3.74v12.63h-3.62V6.29h7.36c3.54,0,6.41,2.88,6.41,6.41v9.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M142.88,22.68c-4.55,0-8.26-3.7-8.26-8.26s3.7-8.26,8.26-8.26,8.26,3.7,8.26,8.26-3.7,8.26-8.26,8.26ZM142.88,9.79c-2.55,0-4.63,2.08-4.63,4.63s2.08,4.63,4.63,4.63,4.63-2.08,4.63-4.63-2.08-4.63-4.63-4.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M83.5,22.68c-4.55,0-8.26-3.7-8.26-8.26s3.7-8.26,8.26-8.26,8.26,3.7,8.26,8.26-3.7,8.26-8.26,8.26ZM83.5,9.79c-2.55,0-4.63,2.08-4.63,4.63s2.08,4.63,4.63,4.63,4.63-2.08,4.63-4.63-2.08-4.63-4.63-4.63Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 94.07,
    y: 0.01,
    width: 3.81,
    height: 22.53
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 128.54,
    y: 6.13,
    width: 3.81,
    height: 16.42
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 130.43,
    cy: 2.52,
    r: 2.1
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M126.18,9.79v-3.62h-4.76v-3.96h-3.62v14.57c0,3.17,2.58,5.74,5.74,5.74h2.64v-3.62h-2.64c-1.17,0-2.12-.95-2.12-2.12v-6.98h4.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M178.65,22.68h-8.1v-3.62h8.1c.66,0,1.2-.54,1.2-1.2,0-.75-.63-1.57-1.2-1.57h-3.33c-2.99,0-5.24-2.1-5.24-4.87s2.35-5.24,5.24-5.24h7.65v3.62h-7.65c-.89,0-1.62.73-1.62,1.62,0,1.19,1.35,1.25,1.62,1.25h3.33c2.57,0,4.83,2.43,4.83,5.2s-2.17,4.83-4.83,4.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M32.24,22.57h-5.44c-5.78,0-10.49-4.71-10.49-10.49S21.01,1.59,26.79,1.59h5.44v3.62h-5.44c-3.79,0-6.87,3.08-6.87,6.87s3.08,6.87,6.87,6.87h5.44v3.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M49.63,22.57h-5.94c-5.78,0-10.49-4.71-10.49-10.49S37.9,1.59,43.68,1.59h6.02v3.62h-6.02c-3.79,0-6.87,3.08-6.87,6.87s3.08,6.87,6.87,6.87h2.32v-6.94h3.62v10.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M66.83,22.52h-8.02v-3.62h8.02c1.42,0,2.93-.72,2.93-2.05,0-1.16-.78-2.18-1.9-2.48l-5.08-1.26c-2.58-.69-4.36-3.01-4.36-5.64,0-3.22,2.62-5.83,5.83-5.83h8.67v3.62h-8.67c-1.22,0-2.21.99-2.21,2.21,0,1,.67,1.88,1.64,2.13l5.08,1.26c2.74.73,4.62,3.19,4.62,5.99,0,3.23-2.82,5.67-6.55,5.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M8.42,22.52H.4v-3.62h8.02c1.42,0,2.93-.72,2.93-2.05,0-1.16-.78-2.18-1.9-2.48l-5.08-1.26C1.78,12.42,0,10.1,0,7.46,0,4.25,2.62,1.63,5.83,1.63h8.67v3.62H5.83c-1.22,0-2.21.99-2.21,2.21,0,1,.67,1.88,1.64,2.13l5.08,1.26c2.74.73,4.62,3.19,4.62,5.99,0,3.23-2.82,5.67-6.55,5.67Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M291.33,22.53h-3.62v-9.84c0-1.54-1.25-2.79-2.79-2.79h-3.74v12.63h-3.62V6.28h7.36c3.54,0,6.41,2.88,6.41,6.41v9.84Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 252.33,
    width: 3.81,
    height: 22.53
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M217.32,6.28h-3.74V0h-3.62v22.53h3.62v-12.63h3.74c1.54,0,2.79,1.25,2.79,2.79v9.84h3.62v-9.84c0-3.53-2.88-6.41-6.41-6.41Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 245.52,
    y: 6.11,
    width: 3.81,
    height: 16.42
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M247.42,4.6c1.16,0,2.1-.94,2.1-2.1s-.94-2.1-2.1-2.1-2.1.94-2.1,2.1.94,2.1,2.1,2.1Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M301.63,22.68c-4.49,0-8.15-3.66-8.15-8.15s3.66-8.15,8.15-8.15h4.58V.13h3.62v14.34c0,4.52-3.68,8.2-8.2,8.2ZM301.63,10c-2.5,0-4.53,2.03-4.53,4.53s2.03,4.53,4.53,4.53,4.58-2.05,4.58-4.58v-4.48h-4.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M274.85,14.43v8.1h-8.2c-4.49,0-8.15-3.66-8.15-8.15,0-4.5,3.66-8.15,8.15-8.15s8.2,3.68,8.2,8.2ZM271.23,18.91v-4.48c0-2.53-2.05-4.58-4.58-4.58s-4.53,2.03-4.53,4.53c0,2.5,2.03,4.53,4.53,4.53h4.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M242.75,14.43v8.1h-8.2c-4.49,0-8.15-3.66-8.15-8.15,0-4.5,3.66-8.15,8.15-8.15s8.2,3.68,8.2,8.2ZM239.12,18.91v-4.48c0-2.53-2.05-4.58-4.58-4.58s-4.53,2.03-4.53,4.53c0,2.5,2.03,4.53,4.53,4.53h4.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M197.74,5.16h-6.05V1.59h15.91v3.58h-6.05v17.37h-3.81V5.16Z"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoThailand);
export default __webpack_public_path__ + "static/media/logo_thailand.24e74e87d4023b03a4a340f5a38b2e2e.svg";
export { ForwardRef as ReactComponent };